import React, {useCallback} from 'react';
import {Collection, useProductsContext} from '../Context/Products/ProductsContext';
import {Common} from '@taopix/taopix-core';
import {useNavigate, useParams} from 'react-router-dom';
import {Heading, Theme, ThemeName} from '@taopix/taopix-design-system';
import useLangCode from '../../Hooks/useLangCode';

const Collections = () => {
  const {state} = useProductsContext();

  const navigate = useNavigate();
  const {groupCode} = useParams();
  const langCode = useLangCode();

  const onSetCollection = (collection: Collection) => {
    navigate(`/products/${groupCode}/${collection.collectionCode}?l=${langCode}`);
  };

  const getThumbnail = useCallback(
    (collection: Collection) => {
      const thumb = `${state.urls.serverURL}${state.urls.thumbnailPath}/products/${collection.collectionCode}/${collection.thumbpath}/${collection.newThumbnailImage}`;
      if ('' === collection.newThumbnailImage) {
        return 'https://placehold.co/100x100';
      }
      return thumb;
    },
    [state.urls]
  );

  if (state.loading) {
    return <></>;
  }

  return (
    <section className="selectCollectionStep-CollectionGrid grid-cols-1 grid min500:grid-cols-2 min800:grid-cols-3 min1100:grid-cols-6 gap-lg overflow-auto mt-md">
      {state.selector.collections.map((collection, index) => {
        return (
          <Theme
            element="section"
            name={ThemeName.Section}
            id={`selectCollectionStep-collectionPanel-${index}`}
            key={`selectCollectionStep-collectionPanel-${index}`}
            className="selectCollectionStep-CollectionPanel group/collectionPanel flex flex-col cursor-pointer hover:outline hover:outline-[2px] hover:outline-themeAccentColour20 outline-offset-[-2px]"
            onClick={event => {
              event.stopPropagation();
              onSetCollection(collection);
            }}
          >
            <Theme
              name={ThemeName.Container}
              id={`selectCollectionStep-collectionPanelImageContainer-${index}`}
              allowBorder={false}
              allowCorners={false}
              className="w-full flex aspect-square relative"
            >
              <img
                id={`selectCollectionStep-collectionPanelImage-${index}`}
                src={getThumbnail(collection)}
                alt={`Collection ${index}`}
                className="object-cover w-full"
              />
            </Theme>
            <div
              id={`selectCollectionStep-collectionPanelNameContainer-${index}`}
              className="flex p-sm items-center"
            >
              <Heading
                id={`selectCollectionStep-collectionPanelName-${index}`}
                size={4}
                className="flex-1"
              >
                {Common.getCurrentLocaleString(collection.collectionName, false)}
              </Heading>
            </div>
          </Theme>
        );
      })}
    </section>
  );
};

export default Collections;
